import { Divider, DividerProps } from "semantic-ui-react";
import styles from "./styles.module.scss";
import classnames from "utilities/classnames";

export type DividerVerticalProps = DividerProps;

export function DividerVertical(props: DividerVerticalProps) {
  const { className, ...rest } = props;
  const classes = classnames(styles.divider, className);

  return (
    <div className={styles.root}>
      <Divider className={classes} {...rest} vertical />
    </div>
  );
}
